export enum CampaignFormLimit {
  Name = 100,
  Description = 3000,
  Subject = 255,
  Body = 10000,
  RecipientsLimit = 250
}
